<template>
  <!-- Content -->
  <div class="content-container">
    <div class="d-flex">
      <!-- Logos -->
      <div class="col-8">
        <img
          class="img-fluid"
          width="350"
          height="50"
          src="/uploads/BARRA_LOGOS-COR-1024x148.png"
        />
      </div>

      <!-- Glossary -->
      <div class="glossary d-flex align-items-end col-4">
        <!-- Clickable text displayed on bottom to open glossary -->
        <p class="glossary-link ms-auto">
          <span @click="showGlossary = true">
            <font-awesome-icon :icon="['fas', 'fa-magnifying-glass']" />
            Ver glossário
          </span>
        </p>
        <!-- When glossary open create overlay outside glossary to click and close -->
        <div
          v-if="showGlossary"
          class="glossary-overlay"
          @click="showGlossary = false"
        ></div>
        <!-- Glossary content to show when glossary open -->
        <div v-if="showGlossary" class="glossary-popup popup">
          <div class="glossary-content">
            <!-- X button to close glossary -->
            <span class="close" @click="showGlossary = false">&times;</span>
            <!-- Title -->
            <h3 class="mb-3">Glossário</h3>
            <!-- List with all definitions -->
            <ul class="glossary-list">
              <li>
                <strong>CELE:</strong> O sistema de Comércio Europeu de Licenças
                de Emissão (CELE) é um mecanismo de cap-and-trade que limita as
                emissões de dióxido de carbono equivalente em instalações fixas
                de diferentes setores. Este limite máximo é expresso em licenças
                de emissão anuais de dióxido de carbono equivalente. As
                instalações abrangidas têm de monitorizar e comunicar as suas
                emissões.
              </li>
              <li>
                <strong>Closed loop supply chain:</strong> Modelo de fabrico no
                qual as empresas reutilizam os subprodutos, introduzindo-os
                novamente no processo produtivo.
              </li>
              <li>
                <strong>Modelos Wall to Wall:</strong> Modelo de fabrico no qual
                as fábricas de fornecedores e clientes estão integradas.
              </li>
              <li>
                <strong>Science-Based Target:</strong> Meta de redução de
                emissões de GEE que está alinhada com o que a ciência climática
                indica ser necessário para limitar o aquecimento global,
                conforme os objetivos do Acordo de Paris. Para mais informação
                consulte o link:
                <a href="https://sciencebasedtargets.org/" target="_blank"
                  >https://sciencebasedtargets.org/</a
                >.
              </li>
              <li>
                <strong>Âmbito 1:</strong> Emissões diretas de Gases com Efeito
                de Estufa (GEE) que ocorrem a partir de fontes controladas ou
                pertencentes à empresa.
              </li>
              <li>
                <strong>Âmbito 2:</strong> Emissões indiretas de Gases com
                Efeito de Estufa (GEE) associadas à compra ou aquisição de
                eletricidade, vapor ou calor consumido na empresa.
              </li>
              <li>
                <strong>Âmbito 3:</strong> Emissões de Gases com Efeito de
                Estufa (GEE) que resultam das atividades na cadeia de valor da
                empresa.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Display currrent path -->
    <div class="form-container col-12">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import eventBus from '@/eventBus.js';

export default {
  data() {
    return {
      showGlossary: false, // Control the visibility of the glossary popup
    };
  },

  created() {
    eventBus.$on('show-glossary', this.showGlossaryMethod);
  },

  // before app unmounts do this:
  beforeUnmount() {
    eventBus.$off('show-glossary', this.showGlossaryMethod);
  },

  watch: {
    // watch for the current route and save it to the state to help router navigation
    $route(to) {
      this.$store.dispatch('updatePreviousRoute', to);
    },
  },

  methods: {
    showGlossaryMethod() {
      this.showGlossary = true;
    },
  },
};
</script>
